import { MealPlan } from '../../../../@core/interfaces/common/CalorieFriend/plan';

/**
 * The class to hold the current plan data.
 */
export class PlanDataService {
  public thePlan: MealPlan ;
}
